import 'intl-pluralrules'; // polyfill
import { createDefaultFormatters, IntlMessageFormat } from 'intl-messageformat';

import Logging from '~app/core/logging';

import Localizer from './Localizer';

export class ReactLocalizer extends Localizer {
  cache = {
    formatters: createDefaultFormatters(),
    messages: {}, // IntlMessageFormat object cache created on demand
  };

  constructor({ language, strings }) {
    super();
    this.strings = strings;
  }

  translate = (msgId, values) => {
    let msg = this.cache.messages[msgId];
    if (!msg) {
      const string = this.strings[msgId];
      Logging.assert(
        string,
        () => `could not find translated string for msgId=${msgId}`,
      );
      msg = this.cache.messages[msgId] = new IntlMessageFormat(string, {
        formatters: this.formatters,
      });
    }
    return msg.format(values);
  };
}

export default ReactLocalizer;
